import { Redirect, RouteComponentProps } from 'react-router-dom';
import Login from './Login';
import {
    GO_TO_CHANGE_DOC,
    GO_TO_LOGIN,
    GO_TO_LOGOUT,
    GO_TO_SETUP_APP,
    INIT,
    REGISTER_ABDM,
} from '../routes/paths';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const AuthWrapper = (Component, path) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return (props: RouteComponentProps) => {
        try {
            if (path === GO_TO_LOGIN) {
                if (window && localStorage.getItem('activeId')) {
                    return <Redirect to={GO_TO_SETUP_APP} {...props} />;
                }

                return <Login {...props} />;
            }

            if (
                path === GO_TO_CHANGE_DOC ||
                path === GO_TO_SETUP_APP ||
                path === INIT ||
                path === REGISTER_ABDM ||
                path === GO_TO_LOGOUT
            ) {
                return <Component {...props} />;
            }

            if (window && !localStorage.getItem('activeId')) {
                return <Redirect to={GO_TO_LOGIN} {...props} />;
            }
        } catch (e) {}

        return <Component {...props} />;
    };
};

export default AuthWrapper;
